import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// import image10 from '../assets/newHeader/image23.jpg';
import whyThisImg from '../assets/public-site/manufacturing_1.png';
import hiwImg from '../assets/public-site/manufacturing_2 .1.png';
import whyThisImg1 from '../assets/public-site/manufacturing_2.png';
import introImg from '../assets/public-site/Manufacturing_Intro.jpg';
import drivingChanges from '../assets/public-site/manyfacturin_group.png';
import wygImg1 from '../assets/public-site/manyfacturin_group_1.svg';
import wygImg2 from '../assets/public-site/manyfacturin_group_2.svg';
import wygImg3 from '../assets/public-site/manyfacturin_group_3.svg';
import wygImg4 from '../assets/public-site/manyfacturin_group_4.svg';
import { ExportedIcon } from '../components/icons/icons';
import { NewFooter } from '../components/Layout/NewFooter';
import { NewNavbar } from '../components/Layout/NewHeader';

import { ConnectForm } from './ConnectUseForm';

export const Manufacturing: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div>
      {/* header */}
      <NewNavbar />

      {/* hero section */}
      <section
        className="
    relative w-full h-[100vh] bg-cover bg-center bg-no-repeat 
    before:absolute before:inset-0 before:z-10 
    lg:before:hidden
    before:bg-gradient-to-r before:from-black before:to-transparent
  "
        style={{
          backgroundImage: `
      linear-gradient(180deg, rgba(0, 0, 0, 0) 47.64%, #000000 100%),
      url(${introImg})
    `,
          backgroundPosition: 'center top',
          backgroundSize: 'cover',
        }}
      >
        <div className="relative z-20 flex items-end justify-center h-full container mx-auto px-6 pb-10 text-white text-center">
          <div className="w-full space-y-6">
            <h1 className="text-4xl sm:text-5xl font-normal">
              Build a stronger frontline-starting with
              <span className="text-[#FFC90D] font-bold"> smarter placement. </span>
            </h1>
            <p className="mt-2 text-lg sm:text-xl !leading-loose font-semibold">
              Vero helps manufacturers surface overlooked talent, reduce churn, and strengthen
              workforce stability by matching people to the roles they’re built for.
            </p>

            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              className="btn btn-primary !px-9 !py-6 hover:underline rounded-md inline-flex items-center gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule a Strategy Session <ExportedIcon />
            </a>
          </div>
        </div>
      </section>

      {/* Why This Still Hurts Section */}
      <section className="py-16">
        <div className="container px-4">
          <br />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mt-8">
            {/* Left Content */}

            <div>
              <div className="mx-auto mt-5">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5 text-center lg:text-left">
                  Retention is a
                  <span className="font-bold text-primary-500"> production issue.</span>
                </h2>
              </div>
              <div className=" pb-7 pt-4">
                <p className="text-black font-normal text-xl leading-[40px] text-center lg:text-left">
                  You’re not just battling a labor shortage. You’re navigating a workforce in
                  transition—retirements are rising, Gen Z brings new expectations, and competition
                  for skilled labor is fiercer than ever. <br /> When the wrong person is on the
                  line, output suffers. Vero helps you align talent from the start—so you can keep
                  your lines running and build from within.
                </p>
              </div>

              <a
                className="btn btn-secondary !whitespace-normal !py-6 !px-8"
                href="https://meetings.hubspot.com/chrissybil/vero-learning"
                target="_blank"
              >
                Explore smarter retention strategies <ExportedIcon />
              </a>
            </div>

            {/* Right Image */}
            <div className="relative w-full">
              <img
                src={whyThisImg}
                alt="Team Collaboration"
                className="w-full h-auto object-cover rounded-xl"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mt-8">
            {/* Left Image */}

            <div className="relative w-full">
              <img
                src={whyThisImg1}
                alt="Team Collaboration"
                className="w-full h-auto object-cover rounded-xl"
              />
            </div>
            {/* Right content */}
            <div>
              <div className="mx-auto mt-5">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5 text-center lg:text-left">
                  Most hiring tools screen out potential.
                  <span className="font-bold text-primary-500"> Vero brings it forward.</span>
                </h2>
              </div>
              <div className=" pb-7 pt-4">
                <p className="text-black font-normal text-xl leading-[40px] text-center lg:text-left">
                  We go beyond resumes to surface natural competencies like spatial reasoning,
                  learning agility, and attention to detail—traits that define high performers in
                  manufacturing but rarely show up on paper.
                </p>
              </div>

              <a
                className="btn btn-secondary !whitespace-normal !py-6 !px-8"
                href="https://meetings.hubspot.com/chrissybil/vero-learning"
                target="_blank"
              >
                Discover hidden frontline potential <ExportedIcon />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className=" py-16 bg-[#E6E8FE]">
        <div className="container mx-auto text-center md:text-left">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[83px] mb-5">
            Built for the floor-not just the
            <span className="font-bold text-primary-500">
              {' '}
              <span className="lg:block">front office.</span>{' '}
            </span>
          </h2>
        </div>

        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10  mt-12">
            {/* Left Column - Text */}
            <div className="col-span-1 text-left  space-y-2">
              <p className="text-2xl">
                Vero supports HR and plant leaders with workforce intelligence designed for:
              </p>
              {[
                {
                  list: [
                    'Operators and assemblers',
                    'Material handlers and line techs',
                    'Maintenance crews and team leads',
                    'First-time workers and career switchers',
                  ],
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="border-dashed border border-purple-200 rounded-[32px] p-7"
                >
                  <p className=" text-lg">
                    {' '}
                    {item.list && (
                      <ul className="text-gray-700  text-lg list-disc list-inside font-semibold">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </p>
                </div>
              ))}
              <p className="text-2xl">We help you :</p>

              {[
                {
                  list: [
                    'Fill roles with real fit—not just availability',
                    'Reduce churn by flagging mismatches before day one',
                    'Uncover untapped local talent',
                    'Fuel promotion pathways and reduce external dependency',
                  ],
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="border-dashed border border-purple-200 rounded-[32px] p-7 "
                >
                  {/* <h3 className="text-2xl mb-2 font-bold">{item.title}</h3> */}
                  <p className=" text-lg">
                    {' '}
                    {item.list && (
                      <ul className="text-gray-700 text-lg list-disc list-inside font-semibold">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </p>
                </div>
              ))}
            </div>

            {/* Right Column - Images */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={hiwImg}
                alt="Team Manufacturing"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section className="pb-16 mt-10">
        <div className="container">
          {/* <p className="text-2xl text-center mb-4">Who We Support</p> */}
          <h2 className="text-4xl sm:text-5xl font-normal md:text-6xl text-center mb-8">
            How Vero Works for
            <span className="text-primary-500  font-bold"> Manufacturers</span>
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
            {/* Employer Card 1 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-primary-200 flex flex-col items-center gap-4 text-center">
              <div className="h-60">
                <img
                  src={wygImg1}
                  alt="Profile your top performers"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <h3 className="text-2xl font-semibold mt-2">Profile your top performers</h3>
              <p className="text-center font-medium text-xl !leading-loose">
                Use real performance data—tenure, output, and feedback—to identify your top
                performers and build a custom success profile.
              </p>
            </div>
            {/* Employer Card 2 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-primary-200 flex flex-col items-center gap-3 text-center">
              <div className="h-60">
                <img
                  src={wygImg2}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <h3 className="text-2xl font-semibold mt-2">Score smarter, not just faster</h3>
              <p className="  text-center font-medium text-xl !leading-loose">
                Vero compares every candidate to your internal benchmarks so you can predict fit
                from day one—not just screen resumes.
              </p>
            </div>
            {/* Employer Card 3 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-primary-200 flex flex-col items-center gap-3 text-center">
              <div className="h-60">
                <img
                  src={wygImg3}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <h3 className="text-2xl font-semibold mt-2">Match workers to where they’ll thrive</h3>
              <p className="  text-center font-medium text-xl !leading-loose">
                Assign people to roles that match their strengths and your plant’s actual needs—not
                just fill open seats.
              </p>
            </div>
            {/* Employer Card 4 */}
            <div className="col-span-1 px-6 py-12 rounded-[40px] bg-primary-200 flex flex-col items-center gap-3 text-center">
              <div className="h-60">
                <img
                  src={wygImg4}
                  alt="For Employers Who Look Beyond the Hire"
                  className="w-full h-auto"
                  loading="lazy" // Added lazy loading for better performance
                />
              </div>
              <h3 className="text-2xl font-semibold mt-2 ">Build internal mobility from day one</h3>
              <p className="  text-center font-medium text-xl !leading-loose">
                Spot coachable potential early. Reduce re-hiring, and support progression from the
                floor up.
              </p>
            </div>
          </div>

          {/* Button Section */}
          <div className="mt-12 text-center px-4 sm:px-0">
            <a
              className="btn btn-secondary w-full sm:w-auto py-4 px-6 text-base sm:text-lg"
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              target="_blank"
              rel="noopener noreferrer"
            >
              See predictive placement in action
              <ExportedIcon />
            </a>
          </div>
        </div>
      </section>

      <section className="pb-16">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-[35%_65%] gap-10 items-center mt-12">
            {/* Left Image */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={drivingChanges}
                alt="driving Changes"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>

            {/* Right Content */}
            <div className="mx-auto md:mt-10 items-center gap-10">
              {/* Header */}
              <div className="mx-auto text-center lg:text-left">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5">
                  Why Manufacturing Teams
                  <span className="font-bold text-primary-500 block">Choose Vero</span>
                </h2>
              </div>
              <div className="text-center md:text-left space-y-6">
                {[
                  {
                    list: [
                      '85% AI job fit accuracy, trained on real factory outcomes',
                      'Built for shift-specific complexity and role variability',
                      'Supports Gen Z retention, upskilling, and cross-training',
                      'Proven across 35,000+ users in manufacturing, logistics, retail, and healthcare',
                      'Works seamlessly with your ATS, ERP, and union-aligned workflows',
                    ],
                  },
                ].map((item, index) => (
                  <div key={index} className="mt-4">
                    {item.list && (
                      <ul className="text-black mt-4 text-xl list-disc list-outside font-normal leading-loose pl-5 text-left">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>

              {/* Bullet List */}
              {/* <div className="text-left mb-6 px-4 sm:px-0 space-y-4">
                <ul className="text-black text-base sm:text-lg list-disc pl-5 font-normal leading-loose">
                  {[
                    '85% AI job fit accuracy, trained on real factory outcomes',
                    'Built for shift-specific complexity and role variability',
                    'Supports Gen Z retention, upskilling, and cross-training',
                    'Proven across 35,000+ users in manufacturing, logistics, retail, and healthcare',
                    'Works seamlessly with your ATS, ERP, and union-aligned workflows',
                  ].map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div> */}

              {/* CTA Button */}
              <div className="mt-10 text-center lg:text-left px-4 sm:px-0">
                <a
                  className="btn btn-secondary !py-4 !px-6 text-sm sm:text-base"
                  href="https://meetings.hubspot.com/chrissybil/vero-learning"
                  target="_blank"
                >
                  Schedule your workforce <br />
                  strategy session
                  <ExportedIcon />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* container 13 */}
      <ConnectForm
        text="When you place the right people in the right roles, you don’t just fill jobs—you power throughput, reduce risk, and strengthen your floor. Vero gives you the insight to do it at scale."
        header="Stop guessing. Start scaling what works."
        buttonText="Book time here"
        actionButtonText="Book your 15-minute demo now"
      />
      <NewFooter />
    </div>
  );
};
